import * as React from 'react';
import { connect } from 'react-redux';
import SalesHeader from '~/apps/pos/mobile/components/sales/SaleHeader';
import PageMobileWrapper from '~/common/elements/mobile/PageMobileWrapper';
import BodyWrapper from '~/common/elements/mobile/BodyWrapper';
import FooterWrapper from '~/common/elements/mobile/FooterWrapper';
import Button from '~/common/elements/mobile/Button';
import { buttonSize, buttonStyle } from '~/common/elements/mobile/consts';


class SalePrintResult extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.handleActions = this.handleActions.bind(this);
  }

  handleActions(actionKey) {
    const { onReturn } = this.props;

    switch (actionKey) {
      case 'print-close':
        if (onReturn) onReturn();
        break;

      case 'other':
        alert('Other');
        break;

      default:
        console.warn(`>>> Not action key: ${actionKey} !!!`)
    }
  }

  render() {

    return (
      <PageMobileWrapper>
        <BodyWrapper>
            <div className="m__ol--dbtns">
              <div className="m__head">
                <span className="m__head__titl m__ol__titl">
                  The receipt was printed successfully
                </span>
                <div className="m__head__right">
                </div>
              </div>
              <FooterWrapper
                customStyle={{ position: 'absolute' }}
              >
                <div
                  className="m__foot__btns"
                >
                  <Button
                    title="Close"
                    actionKey="print-close"
                    buttonStyle={buttonStyle.LITE}
                    buttonSize={buttonSize.XLG}
                    onClick={actionKey => {
                      this.handleActions(actionKey)
                    }}
                  />
                </div>
              </FooterWrapper>
            </div>
        </BodyWrapper>
      </PageMobileWrapper>
    )
  }
}


const mapStateToProps = (state) => {
  return {}
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalePrintResult);
